'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _FilterButton = require('components/FilterButton/FilterButton');

var _FilterButton2 = _interopRequireDefault(_FilterButton);

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _statistics2 = require('helpers/statistics');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./StatisticsPeriod.scss');

var StatisticsPeriod = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    periodName: state.statistics.periodName
  };
}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(StatisticsPeriod, _Component);

  function StatisticsPeriod() {
    (0, _classCallCheck3.default)(this, StatisticsPeriod);
    return (0, _possibleConstructorReturn3.default)(this, (StatisticsPeriod.__proto__ || (0, _getPrototypeOf2.default)(StatisticsPeriod)).apply(this, arguments));
  }

  (0, _createClass3.default)(StatisticsPeriod, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var periodName = this.props.periodName;

      if (!periodName) {
        this.setPeriodWeek();
      }
    }
  }, {
    key: 'setPeriodWeek',
    value: function setPeriodWeek() {
      this.props.setPeriod({ periodName: _statistics2.reportPeriods.week });
    }
  }, {
    key: 'setPeriodMonth',
    value: function setPeriodMonth() {
      this.props.setPeriod({ periodName: _statistics2.reportPeriods.month });
    }
  }, {
    key: 'setPeriodCustom',
    value: function setPeriodCustom() {
      this.props.setPeriodName({ periodName: _statistics2.reportPeriods.custom });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          periodName = _props.periodName;
      var t = this.context.t;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.periodContainer, className) },
        _react2.default.createElement(_FilterButton2.default, {
          onClick: this.setPeriodWeek,
          title: t('Last week'),
          isActive: periodName === _statistics2.reportPeriods.week,
          responsive: false
        }),
        _react2.default.createElement(_FilterButton2.default, {
          onClick: this.setPeriodMonth,
          title: t('Last month'),
          isActive: periodName === _statistics2.reportPeriods.month,
          responsive: false
        }),
        _react2.default.createElement(_FilterButton2.default, {
          onClick: this.setPeriodCustom,
          title: t('Custom'),
          isActive: periodName === _statistics2.reportPeriods.custom,
          responsive: false
        })
      );
    }
  }]);
  return StatisticsPeriod;
}(_react.Component), _class3.propTypes = {
  className: _propTypes2.default.string,
  periodName: _propTypes2.default.string,
  setPeriod: _propTypes2.default.func,
  setPeriodName: _propTypes2.default.func
}, _class3.contextTypes = {
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'setPeriodWeek', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setPeriodWeek'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setPeriodMonth', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setPeriodMonth'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setPeriodCustom', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setPeriodCustom'), _class2.prototype)), _class2)) || _class);
exports.default = StatisticsPeriod;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/StatisticsPeriod/StatisticsPeriod.js
// module id = 2124
// module chunks = 1